import { render, staticRenderFns } from "./areaFeedbackList.vue?vue&type=template&id=1cbb4ab7&scoped=true"
import script from "./areaFeedbackList.vue?vue&type=script&lang=js"
export * from "./areaFeedbackList.vue?vue&type=script&lang=js"
import style0 from "./areaFeedbackList.vue?vue&type=style&index=0&id=1cbb4ab7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbb4ab7",
  null
  
)

export default component.exports